<script>
  // Teaching empty state: a short title that explains the absence and an
  // optional body line, with a slot for a call-to-action button. Use this
  // instead of a bare grey "Nessun dato" row.
  export let title = '';
  export let body = '';
  export let icon = null; // optional icon component from lib/icons
</script>

<div class="p-10 text-center flex flex-col items-center" role="status" aria-live="polite">
  {#if icon}
    <svelte:component this={icon} size={32} class="mb-3 text-action/70" />
  {/if}
  {#if title}
    <p class="font-bold text-heading">{title}</p>
  {/if}
  {#if body}
    <p class="mt-1 text-sm text-muted max-w-md">{body}</p>
  {/if}
  <div class="mt-4 empty-cta">
    <slot />
  </div>
</div>
